import { Observable } from 'rxjs';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export abstract class AbstractCustomRuleFormSectionWebComponent extends BaseWebComponentElement {
  // returns form values
  abstract get value(): any;

  // returns if form is valid
  abstract get valid(): boolean;

  // observer for validation -> should return a formGroup.valid$
  abstract get valid$(): Observable<boolean>;

  // reset form
  abstract reset(): void;

  // sets data when editing or importing rule
  abstract setData(ruleData: any): void;
}
